module.exports = __webpack_public_path__ + "media/images/footer_page/faq/bg-792278f0bcdac19746a7577bcf9bbf19.svg";